import React, { useState, useEffect } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { createtNotificationTemplates } from "../../api/createNotificationTemplate";
import { useNavigate } from "react-router-dom";
import { getAllUsers } from "../../api/getAllUser";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";

const NotificationForm = ({ onSubmit }) => {
  const [userId, setUserId] = useState([]);
  const selectAllOption = { label: "Select All", value: "Select All" };
  const [textContent, setTextContent] = useState("");
  const [title, setTitle] = useState("");
  const [navigateScreen, setnavigateScreen] = useState("");
  const [date, setDate] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [triggerTime, setTriggerTime] = useState("");
  const [triggerDays, setTriggerDays] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const response = await getAllUsers();
        if (!response.some((item) => item.value === selectAllOption.value)) {
          response.unshift(selectAllOption);
        }
        setAllUsers(response);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchAllUsers();
    setDisabled(false);
  }, []);

  const dayOptions = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
  ];

  const validateForm = () => {
    const errors = {};
    if (userId.length === 0)
      errors.userId = "At least one user must be selected.";
    if (!title) errors.title = "Title is required.";
    if (!dateRange[0] || !dateRange[1])
      errors.dateRange = "Date range is required.";
    if (!triggerTime) errors.triggerTime = "Trigger time is required.";
    if (triggerDays.length === 0)
      errors.triggerDays = "At least one day must be selected.";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const fromDate = moment(dateRange[0]).format("YYYY-MM-DD");
    const toDate = moment(dateRange[1]).format("YYYY-MM-DD");

    const formData = {
      userId: userId.map((user) => user.value),
      textContent,
      fromDate,
      toDate,
      triggerTime,
      triggerMonth: getMonthsFromDates(dateRange),
      triggerDays: triggerDays.map((day) => day.value),
      navigate: navigateScreen,
      title,
      dateToShow: date, // assuming this is a number array (date numbers)
    };

    try {
      const response = await createtNotificationTemplates(formData);
      if (response?.fromDate) {
        toast.success("Notification template created");
        navigate("/notification-template");
        setDisabled(true);
      }
    } catch (error) {
      console.error("API Error:", error.message);
      toast.error("Failed to create notification template.");
    }
  };

  function setUserOnChange(newSelectedOptions) {
    setUserId(newSelectedOptions);
  }

  const getMonthsFromDates = (dates) => {
    const startDate = moment(dates[0]);
    const endDate = moment(dates[1]);
    const months = [];
    let current = startDate.clone();
    while (current.isSameOrBefore(endDate, 'month')) {
      const month = current.month() + 1; // 0-indexed
      if (!months.includes(month)) months.push(month);
      current.add(1, 'month');
    }
    return months;
  };

  return (
    <div className="p-5">
      <Form onSubmit={handleSubmit}>
        <Row className="align-items-center">
          <Col>
            <h1>Create Templates</h1>
          </Col>
          <Col className="text-right">
            <Button className="my-3" onClick={() => navigate("/notification-template")}>
              Go Back
            </Button>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="userId">
              <Form.Label>To</Form.Label>
              <Select
                isMulti
                options={allUsers}
                value={userId}
                onChange={setUserOnChange}
                placeholder="Select Users"
              />
              {errors.userId && (
                <Form.Text className="text-danger">{errors.userId}</Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="title">
              <Form.Label>{`Notification Title`}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter notification title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              {errors.title && (
                <Form.Text className="text-danger">{errors.title}</Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="textContent">
              <Form.Label>Notification Message Content</Form.Label>
              <Form.Control
                as="textarea"
                type="text"
                rows={3}
                placeholder="Enter notification content as short message"
                value={textContent}
                onChange={(e) => setTextContent(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="navigateScreen">
              <Form.Label>
                Which screen needs to popup on clicking notification
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Home"
                value={navigateScreen}
                onChange={(e) => setnavigateScreen(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="dateRange">
              <Form.Label>Which dates notification to be sent</Form.Label>
              <DatePicker
                selectsRange
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                onChange={(update) => {
                  setDateRange(update);
                  if (update?.length > 1 && update[1]) {
                    const dates = [];
                    const start = moment(update[0]);
                    const end = moment(update[1]);
                    let current = start.clone();
                    while (current.isSameOrBefore(end, 'day')) {
                      dates.push(current.date()); // Only push day of month
                      current.add(1, 'day');
                    }
                    setDate(dates);
                  }
                }}
                isClearable={true}
                placeholderText="Select date range"
                className="form-control"
              />
              {errors.dateRange && (
                <Form.Text className="text-danger">
                  {errors.dateRange}
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="triggerTime">
              <Form.Label>Trigger Time</Form.Label>
              <Form.Control
                type="time"
                value={triggerTime}
                onChange={(e) => setTriggerTime(e.target.value)}
              />
              {errors.triggerTime && (
                <Form.Text className="text-danger">
                  {errors.triggerTime}
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="triggerDays">
              <Form.Label>Trigger Days</Form.Label>
              <Select
                isMulti
                options={dayOptions}
                value={triggerDays}
                onChange={setTriggerDays}
                placeholder="Select Days"
              />
              {errors.triggerDays && (
                <Form.Text className="text-danger">
                  {errors.triggerDays}
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Button variant="primary" type="submit" disabled={disabled}>
          Submit
        </Button>
      </Form>
      <ToastContainer />
    </div>
  );
};

export default NotificationForm;
